import SwitchingCategoriesIcon from "../../../assets/Switching/switchingCategoriesIcon.svg";
import type { ProductGroup } from "../../../types";

export const twoPointFiveTenGigabitEthernet: ProductGroup = {
  id: "twoPointFiveTenGigabitEthernet",
  title: "productGroup.twoPointFiveTenGigabitEthernet.title",
  icon: {
    src: SwitchingCategoriesIcon,
    width: 64,
    height: 40,
  },
};
